import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Button,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TableHead,
  IconButton,
  Collapse,
  TableContainer,
  Paper,
} from '@material-ui/core';
import KenGrid from '../../global_components/KenGrid';
import KenInputField from '../../global_components/KenInputField';
import KenSelectWrap from '../../global_components/KenSelect';
import KenLoader from '../../Components/KenLoader/index';
import KenSnackBar from '../../Components/KenSnackbar';
import { useHistory, useLocation } from 'react-router-dom';
import routes from '../../Utils/routes.json';
import {
  getCourseEvalCompAndSubComp,
  getCourseComponents,
  postCourseEvalCompAndSubComp,
  deleteCourseEvaluationComponent,
} from '../../Utils/apiServices';
import './style.scss';
import DeleteIcon from '@material-ui/icons/Delete';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import EditIcon from '@material-ui/icons/Edit';
import GradingData from './data.json';
import Filters from '../../Components/Filters/Filters';

const useStyles = makeStyles((theme) => ({
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    margin: '20px 0px',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
}));
const GradingSetup = () => {
  const classes = useStyles();
  const history = useHistory();
  const userDetails = localStorage.getItem('userDetails');
  const [loader, setLoader] = React.useState(false);
  const [data, setData] = useState([]);
  const [selectedSection, setSelectedSection] = React.useState('');
  const [selectOptionsMasterComponent, setMasterComponent] = useState([]);
  const [selectOptionsNumberOfSubCom, setSubComponent] = useState(
    GradingData.selectOptionsNumberOfSubCom
  );
  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };
  const MasterComponentCell = (row) => {
    const { isEditing, MasterComponent } = row.row.values;
    return (
      <>
        {isEditing ? (
          <div className="kenSelect-wrap">
            <KenSelectWrap
              options={selectOptionsMasterComponent}
              value={MasterComponent}
              name="MasterComponent"
              dropdownColor="#FFFFFF"
              onChange={(e) => handleSelectChangeMaster(e, row.row.index)}
              required
            />
          </div>
        ) : (
          <Typography>{MasterComponent}</Typography>
        )}
      </>
    );
  };
  const MasterWeigtageCell = (row) => {
    const { isEditing, weightage } = row.row.values;
    const { id } = row.row.original;
    return (
      <>
        {isEditing ? (
          <KenInputField
            value={weightage}
            name="weightage"
            optionalLabel={false}
            onChange={(event) =>
              handleChangeWeightage(event, row.row.index, id)
            }
            style={{ fontSize: 12 }}
          />
        ) : (
          <Typography>{weightage}</Typography>
        )}
      </>
    );
  };
  const MasterSubComponentCell = (row) => {
    const { isEditing, NumberOfSubCom } = row.row.values;
    return (
      <>
        {isEditing ? (
          <div className="kenSelect-wrap">
            <KenSelectWrap
              options={selectOptionsNumberOfSubCom}
              value={NumberOfSubCom}
              name="NumberOfSubCom"
              dropdownColor="#FFFFFF"
              onChange={(e) => handleSelectChangeSubCom(e, row.row.index)}
              required
            />
          </div>
        ) : (
          <Typography>{NumberOfSubCom}</Typography>
        )}
      </>
    );
  };
  const MasterEditCell = (row) => {
    const { isEditing } = row.row.values;
    const { id } = row.row.original;
    return (
      <>
        {isEditing ? (
          <IconButton
            variant="contained"
            color="error"
            onClick={() => saveRowHandle(id)}
          >
            <DoneAllIcon />
          </IconButton>
        ) : (
          <IconButton
            variant="contained"
            color="error"
            onClick={() => editRowHandle(id)}
          >
            <EditIcon />
          </IconButton>
        )}
      </>
    );
  };
  const MasterDeleteCell = (row) => {
    const { id } = row.row.original;
    return (
      <>
        <IconButton
          variant="contained"
          color="error"
          onClick={() => deleteRowHandle(id, row.row.index)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  const gradingHead = [
    {
      Header: '',
      accessor: 'cursor',
      disableGlobalFilter: false,
    },
    {
      Header: 'Component',
      accessor: 'MasterComponent',
      disableGlobalFilter: false,
      isEditMode: false,
      Cell: MasterComponentCell,
    },
    {
      Header: 'weightage %',
      accessor: 'weightage',
      disableGlobalFilter: false,
      isEditMode: false,
      Cell: MasterWeigtageCell,
    },
    {
      Header: 'Number of SubComponents',
      accessor: 'NumberOfSubCom',
      disableGlobalFilter: false,
      isEditMode: false,
      Cell: MasterSubComponentCell,
    },
    {
      Header: 'Edit',
      accessor: 'isEditing',
      disableGlobalFilter: false,
      isEditMode: false,
      Cell: MasterEditCell,
    },
    {
      Header: 'Delete',
      accessor: 'delete',
      disableGlobalFilter: false,
      isEditMode: false,
      Cell: MasterDeleteCell,
    },
  ];
  const handleSelectChangeMaster = (e, index) => {
    let tempData = data;
    tempData[index].MasterComponent = e.target.value;
    setData([...tempData]);
  };
  const handleChangeWeightage = (evt, index, id) => {
    setData((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            weightage: Number(evt.target.value),
          };
        } else {
          return item;
        }
      });
    });
  };
  const handleSelectChangeSubCom = (e, index) => {
    let tempData = data;
    tempData[index].NumberOfSubCom = e.target.value;
    setData([...tempData]);
  };
  const saveRowHandle = (id) => {
    const filteredWeight = data.map((item) => item.weightage);
    const checkWeightage = filteredWeight.reduce((a, b) => a + b, 0);
    if (checkWeightage <= 100) {
      const saveData = data.filter((item) => item.id === id);
      const newSubList = [];
      saveData.forEach((item) => {
        const updatedList = [];
        const filteredWeight2 = item?.subComp.map((item2) => {
          return !isNaN(item2.subweightage) ? item2.subweightage : 0;
        });
        const checkWeightage2 = filteredWeight2.reduce((a, b) => a + b, 0);
        let currentWeightage = 100 - Number(checkWeightage2);
        for (
          let i = saveData[0]?.subComp.length;
          i < item?.NumberOfSubCom;
          i++
        ) {
          var newIndex = i + 1;
          updatedList.push({
            id: '',
            subComponent: `${item.MasterComponent}` + ' ' + newIndex,
            subweightage: Math.round(
              currentWeightage /
                (item?.NumberOfSubCom - saveData[0]?.subComp.length)
            ),
            isEditing: false,
          });
        }
        newSubList.push(...saveData[0]?.subComp, ...updatedList);
      });
      saveData[0].subComp = newSubList;
      submitMasterComponent(saveData);
    } else {
      handleSnackbarOpen('info', 'total weightage cannot be more than 100');
    }
  };
  const editRowHandle = (id) => {
    setData((prev) => {
      return prev.map((item) => {
        if (item.id == id) {
          return {
            ...item,
            isEditing: true,
          };
        } else {
          return item;
        }
      });
    });
  };
  const deleteRowHandle = (id, index) => {
    setLoader(true);
    let querry = `?componentId=${id}`;
    deleteCourseEvaluationComponent(querry)
      .then((res) => {
        console.log(res);
        handleSnackbarOpen('success', 'Record deleted');
        let querry = `/?courseOfferingId=${selectedSection}`;
        getGradingData(querry);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
        handleSnackbarOpen('error', err.message);
      });
  };
  const addNewMasterComponent = (index) => {
    const filteredWeight = data.map((item) => item.weightage);
    const checkWeightage = filteredWeight.reduce((a, b) => a + b, 0);
    if (checkWeightage < 100) {
      setData((prevState) => {
        return [
          ...prevState,
          {
            id: '',
            MasterComponent: '',
            NumberOfSubCom: '',
            weightage: '',
            subComp: [],
            isEditing: true,
          },
        ];
      });
    } else {
      handleSnackbarOpen('info', 'Total weightage is cannot be more than 100%');
    }
  };
  const submitMasterComponent = (saveData) => {
    let payload = [];
    setLoader(true);
    saveData.map((item) => {
      let subData = [];
      if (item.subComp.length > 0) {
        item.subComp.map((item2) => {
          subData.push({
            subComponentid: item2.id,
            subComponentName: item2.subComponent,
            subcompWeightageCompPercent: item2.subweightage,
          });
        });
      } else {
        subData = [];
      }
      payload.push({
        componentId: item.id,
        componentName: item.MasterComponent,
        numberofSubcomps: item.NumberOfSubCom,
        weightagePercent: item.weightage,
        subComponents: subData,
      });
    });
    console.log('payload', payload);
    postCourseEvalCompAndSubComp(payload)
      .then((res) => {
        handleSnackbarOpen('success', res.message);
        let querry = `/?courseOfferingId=${selectedSection}`;
        getGradingData(querry);
        setLoader(false);
      })
      .catch((err) => {
        handleSnackbarOpen('error', err.message);
        let querry = `/?courseOfferingId=${selectedSection}`;
        getGradingData(querry);
        setLoader(false);
      });
  };
  const handleSectionChange = (e) => {
    setSelectedSection(e.target.value);
    let querry = `/?courseOfferingId=${e.target.value}`;
    getGradingData(querry);
  };
  const getGradingData = (querry) => {
    setLoader(true);
    getCourseEvalCompAndSubComp(querry)
      .then((res) => {
        console.log(res);
        let data = [];
        if (res?.data?.length > 0) {
          res?.data.map((item) => {
            let subData = [];
            if (item.subComponent.length > 0) {
              item.subComponent.map((item2) => {
                subData.push({
                  id: item2.subComponentid,
                  subComponent: item2.subComponentName,
                  subweightage: !isNaN(item2.subcompWeightageCompPercent)
                    ? Number(item2.subcompWeightageCompPercent)
                    : 0,
                  isEditing: false,
                });
              });
            } else {
              subData = [];
            }
            data.push({
              id: item.componentId,
              MasterComponent: item.componentName,
              NumberOfSubCom: item.numberofSubcomps,
              weightage: !isNaN(item.weightagePercent)
                ? Number(item.weightagePercent)
                : 0,
              isEditing: false,
              cursor: false,
              subComp: subData,
            });
          });
        }
        setData(data);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getCourseComponents().then((res) => {
      console.log(res);
      let options = [];
      if(res.length > 0){
        res?.data.map((item) => {
          options.push({
            label: item,
            value: item,
          });
        });
        setMasterComponent(options);
      }
    });
  }, []);
  return (
    <>
      {loader ? <KenLoader /> : null}
      <KenSnackBar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar style={{ minHeight: 40 }}>
          <Typography variant="h6" className={classes.title}>
            Grading Setup
          </Typography>
        </Toolbar>
      </AppBar>
      <Grid item xs={12}>
        <Filters
          style={{ width: '100%' }}
          term={true}
          CourseVersion={true}
          courseoff={true}
          handleSectionChange={handleSectionChange}
          selectedSection={selectedSection}
          CourseEvaluationComponent={false}
        />
      </Grid>
      <div className="grading-setup-table">
        {data && data.length > 0 ? (
          <>
            <KenGrid
              columns={gradingHead}
              data={data}
              pagination={{ disabled: true }}
              toolbarDisabled={true}
              isCollasable={true}
              component={CollapseData}
            />
            <Grid item xs={12} sm={3} style={{ margin: '20px 0px 20px 10px' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => addNewMasterComponent(e)}
              >
                + Add Row
              </Button>
            </Grid>
          </>
        ) : null}
      </div>
    </>
  );
};
const CollapseData = (props) => {
  const propsData = props?.original;
  const [loader, setLoader] = React.useState(false);
  const [data, setData] = useState([]);
  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  useEffect(() => {
    setData(propsData?.subComp);
  }, [propsData]);

  const SubComponentCell = (row) => {
    const { isEditing, subComponent } = row.row.values;
    return (
      <>
        {isEditing ? (
          <KenInputField
            value={subComponent}
            optionalLabel={false}
            name="subComponent"
            onChange={(event) => handleChangeSubComponent(event, row.row.index)}
            style={{ fontSize: 12 }}
          />
        ) : (
          <Typography>{subComponent}</Typography>
        )}
      </>
    );
  };
  const SubWeigtageCell = (row) => {
    const { isEditing, subweightage } = row.row.values;
    const { id } = row.row.original;
    return (
      <>
        {isEditing ? (
          <KenInputField
            value={subweightage}
            optionalLabel={false}
            name="subweightage"
            onChange={(event) =>
              handleChangeSubWeightage(event, row.row.index, id)
            }
            style={{ fontSize: 12 }}
          />
        ) : (
          <Typography>{subweightage}</Typography>
        )}
      </>
    );
  };
  const SubEditCell = (row) => {
    const { isEditing } = row.row.values;
    const { id } = row.row.original;
    return (
      <>
        {isEditing ? (
          <IconButton
            variant="contained"
            color="error"
            onClick={() => saveRowHandle(id, row.row.index)}
          >
            <DoneAllIcon />
          </IconButton>
        ) : (
          <IconButton
            variant="contained"
            color="error"
            onClick={() => editRowHandle(id, row.row.index)}
          >
            <EditIcon />
          </IconButton>
        )}
      </>
    );
  };
  const SubDeleteCell = (row) => {
    const {} = row.row.values;
    const { id } = row.row.original;
    return (
      <>
        <IconButton
          variant="contained"
          color="error"
          onClick={(e) => deleteRowHandle(e, row.row.index, id)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  const gradingSubHead = [
    {
      Header: 'Sub Component',
      accessor: 'subComponent',
      disableGlobalFilter: false,
      isEditMode: false,
      Cell: SubComponentCell,
    },
    {
      Header: 'weightage %',
      accessor: 'subweightage',
      disableGlobalFilter: false,
      isEditMode: false,
      Cell: SubWeigtageCell,
    },
    {
      Header: 'Edit',
      accessor: 'isEditing',
      disableGlobalFilter: false,
      isEditMode: false,
      Cell: SubEditCell,
    },
    {
      Header: 'Delete',
      accessor: 'delete',
      disableGlobalFilter: false,
      isEditMode: false,
      Cell: SubDeleteCell,
    },
  ];
  const handleChangeSubComponent = (e, index) => {
    let tempData = data;
    tempData[index].subComponent = e.target.value;
    setData([...tempData]);
  };
  const handleChangeSubWeightage = (e, index, id) => {
    setData((prev) => {
      return prev.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            subweightage: Number(e.target.value),
          };
        } else {
          return item;
        }
      });
    });
  };
  const saveRowHandle = (id, index) => {
    setData((prev) => {
      return prev.map((item) => {
        if (item.id == id) {
          return {
            ...item,
            isEditing: false,
          };
        } else {
          return item;
        }
      });
    });
  };
  const editRowHandle = (id) => {
    setData((prev) => {
      return prev.map((item) => {
        if (item.id == id) {
          return {
            ...item,
            isEditing: true,
          };
        } else {
          return item;
        }
      });
    });
  };
  const deleteRowHandle = (e, idx, id) => {
    setLoader(true);
    let querry = `?subComponentid=${id}`;
    deleteCourseEvaluationComponent(querry)
      .then((res) => {
        console.log(res);
        handleSnackbarOpen('success', 'Record deleted');
        // reloadGET()
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
        handleSnackbarOpen('error', err.message);
      });
  };

  return (
    <div>
      {loader ? <KenLoader /> : null}
      <KenSnackBar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      {data.length > 0 ? (
        <KenGrid
          columns={gradingSubHead}
          data={data}
          pagination={{ disabled: true }}
          toolbarDisabled={true}
        />
      ) : null}
    </div>
  );
};
export default GradingSetup;
